import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { auth, getListing, deleteListing } from '../firebase';
import './HostingDetail.css';

function HostingDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [listing, setListing] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentPhotoIndex, setCurrentPhotoIndex] = useState(0);
  const [error, setError] = useState('');

  const fetchListing = useCallback(async () => {
    try {
      const data = await getListing(id);
      if (!data) {
        setError('Listing not found');
        setLoading(false);
        return;
      }
      if (data.userId !== auth.currentUser.uid) {
        setError('You can only view your own listings');
        setLoading(false);
        return;
      }
      setListing(data);
    } catch (error) {
      setError('Failed to fetch listing');
    }
    setLoading(false);
  }, [id]);

  useEffect(() => {
    fetchListing();
  }, [fetchListing]);

  const handleDelete = async () => {
    if (!window.confirm('Are you sure you want to delete this listing? This action cannot be undone.')) {
      return;
    }

    try {
      await deleteListing(id, auth.currentUser.uid);
      alert('Listing deleted successfully!');
      navigate('/hosting');
    } catch (error) {
      setError(error.message || 'Failed to delete listing');
    }
  };

  const handleUnlist = () => {
    alert('Unlist feature coming soon...');
  };

  if (loading) return <div className="loading">Loading...</div>;
  if (error && !listing) return (
    <div className="error-container">
      <p className="error">{error}</p>
      <button onClick={() => navigate('/hosting')}>Back to Hosting</button>
    </div>
  );
  if (!listing) return <div className="loading">Listing not found</div>;

  return (
    <div className="hosting-detail-container">
      <button onClick={() => navigate('/hosting')} className="back-btn">← Back to Hosting</button>

      <div className="detail-content">
        <div className="photos-section">
          <div className="main-photo">
            <img src={listing.photos[currentPhotoIndex]} alt={listing.title} />
          </div>
          <div className="thumbnail-photos">
            {listing.photos.map((photo, index) => (
              <img
                key={index}
                src={photo}
                alt={`${listing.title} ${index + 1}`}
                className={index === currentPhotoIndex ? 'active' : ''}
                onClick={() => setCurrentPhotoIndex(index)}
              />
            ))}
          </div>
        </div>

        <div className="info-section">
          <h1>{listing.title}</h1>
          <p className="location">📍 {listing.location}</p>

          <div className="price-details">
            <div className="price">${listing.price}/month</div>
            <div className="specs">
              <span>🛏️ {listing.beds} Bedrooms</span>
              <span>🚿 {listing.baths} Bathrooms</span>
            </div>
          </div>

          <div className="description-section">
            <h2>About this listing</h2>
            <p>{listing.description}</p>
          </div>

          {listing.airbnbUrl && (
            <div className="airbnb-link">
              <h3>Airbnb Link:</h3>
              <a href={listing.airbnbUrl} target="_blank" rel="noopener noreferrer">
                View on Airbnb →
              </a>
            </div>
          )}

          <div className="actions-section">
            <button 
              className="action-btn edit-btn"
              onClick={() => navigate(`/listing/${id}/edit`)}
            >
              ✏️ Edit
            </button>
            <button 
              className="action-btn unlist-btn"
              onClick={handleUnlist}
            >
              👁️ Unlist
            </button>
            <button 
              className="action-btn view-btn"
              onClick={() => navigate(`/listing/${id}`)}
            >
              🔍 View Public
            </button>
            <button 
              className="action-btn delete-btn"
              onClick={handleDelete}
            >
              🗑️ Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HostingDetail;
